var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm_duty_container"},[_c('div',{class:_vm.mobileClass('cm_duty_box_outer')},[_c('NewsNav'),_c('router-view',{attrs:{"data":_vm.ele}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }